<template>
  <common-dialog
    ref="dialog"
    title="Edit Order Type"
    :inputs-map="form"
    :save-cb="saveOrderType"
    :reset-inputs="resetOrderType"
  >
  </common-dialog>
</template>
<script>
// msg
import PagesMessage from '@/core/message/pages'
//
import cloneDeep from 'lodash/cloneDeep'
import { OrderModifyTypeForm } from '@/core/models/order'
import { modifyOrder } from '@/api/order'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
export default {
  name: 'OrderTypeEdit',
  props: {
    orderId: {
      type: String,
      required: true
    }
  },
  components: {
    CommonDialog
  },
  data() {
    return {
      originalType: '',
      form: cloneDeep(OrderModifyTypeForm)
    }
  },
  methods: {
    open(type) {
      this.originalType = type
      this.form[0].value = type
      this.$refs.dialog.open()
    },
    saveOrderType(_, done, error) {
      const toType = this.form[0].value
      if (toType === this.originalType) {
        // type cannot be the same
        error('Order type is the same!')
      } else {
        modifyOrder(this.orderId, { type: this.form[0].value })
          .then(res => {
            if (res) {
              this.$message.success('Change type successfully!')
              PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
            }
          })
          .catch(err => {
            error(err)
          })
      }
    },
    resetOrderType() {
      this.form[0].value = this.originalType
    },
    close() {
      this.$refs.dialog.close()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
